import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-d69c7e7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-option-child" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "delete",
  class: "delete-icon"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "delete-view"
}
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback"
}

import { translate } from '@/languages/i18n'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { computed } from 'vue'
import { minLength, required } from '@vuelidate/validators'
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { REGEX_EMOJI } from '@/constants/regex'
import useVuelidate from '@vuelidate/core'
import { customMaxLength } from '@/utils'
import { watch } from 'vue'
import { ref } from 'vue'
import commonService from '@/services/common.service'
import { debounce } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  props: {
  indexRow: {
    type: Number,
  },
  indexOption: {
    type: Number,
  },
  dataItem: {
    type: String,
  },
},
  emits: ['deleteOptionAction', 'updateData'],
  setup(__props, { emit }) {

const props = __props


const dataCheck = ref({
  valueCheck: props.dataItem,
})


watch(
  () => props.dataItem,
  () => {
    dataCheck.value.valueCheck = props.dataItem
  }
)

const rules = computed(() => {
  return {
    valueCheck: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 50),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
      ngWord: () => !ngWordValueCheck.value,
    },
  }
})
const deleteOption = () => {
  emit('deleteOptionAction', props.indexOption, props.indexRow)
}
const onInput = async (event) => {
  emit('updateData', event.target.value?.trim())
}

const ngWordValueCheck = ref<boolean>(false)

const isCheckedNgWord = { value: false }

const checkNgWordValueCheck = debounce(async () => {
  v$.value.$touch()
  const queryData = { sentence: v$.value.valueCheck.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngWordValueCheck.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNgWord.value = true
  }
}, 200)

const v$ = useVuelidate(rules, dataCheck)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["row-chill", [ngWordValueCheck.value || _unref(v$).valueCheck.$error ? 'is-invalid' : '']])
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        name: "communityName",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).valueCheck.$model) = $event)),
        onInput: onInput,
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNgWordValueCheck) && _unref(checkNgWordValueCheck)(...args))),
        class: _normalizeClass(['form-control']),
        placeholder: _unref(translate)('placeholder')
      }, null, 40, _hoisted_2), [
        [
          _vModelText,
          _unref(v$).valueCheck.$model,
          void 0,
          { trim: true }
        ]
      ]),
      (__props.indexRow > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "delete-view",
            onClick: deleteOption
          }, _hoisted_4))
        : (_openBlock(), _createElementBlock("div", _hoisted_5))
    ], 2),
    _createVNode(InputErrorMessage, {
      title: _unref(translate)('option') + `${__props.indexRow + 1} `,
      params: [1, 50],
      validator: _unref(v$).valueCheck.$errors[0]?.$validator
    }, null, 8, ["title", "validator"]),
    (ngWordValueCheck.value && !_unref(v$).valueCheck.$error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})